import { render, staticRenderFns } from "./AutoSacrificeEffectTab.vue?vue&type=template&id=6f5f01ec&scoped=true&"
import script from "./AutoSacrificeEffectTab.vue?vue&type=script&lang=js&"
export * from "./AutoSacrificeEffectTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f01ec",
  null
  
)

export default component.exports